function isTrialOfType(trialRow, type) {
    const STIM_TYPES = {
        'instructions': 0,
        'image': 1,
        'word': 2,
        'audio': 3,
        'video': 4,
        'survey': 5,
        'form': 6,
        'app': 7
    }

    return window.listStimType[trialRow] === STIM_TYPES[type];
}

function isTrialMediaType(trialRow) {
    return isTrialOfType(trialRow, 'image') || isTrialOfType(trialRow, 'video') || isTrialOfType(trialRow, 'audio');
}

function getStimTrialExtension(trialRow) {
    let currentStimType = window.columnForTrial('stimFormat', trialRow);

    if (isTrialFromList(trialRow)) {
        const firstStim = getStimFromListsForTrialByIndex(trialRow, 0);
        const firstStimExtension = '.' + getFilenameExtension(firstStim);

        return firstStimExtension;
    }

    return currentStimType;
}

function computeTrialType(trialIndex) {

    if (!isTrialFromList(trialIndex)) {
        return computeTrialTypeFromStimFormat(trialIndex);
    }

    // trial with lists
    return computeTrialTypeFromList(trialIndex);

    function computeTrialTypeFromList(trialIndex) {
        const firstStim = getStimFromListsForTrialByIndex(trialIndex, 0);
        let firstStimExtension = '.' + getFilenameExtension(firstStim);

        // if no extension was found and this is not an instructions (instructions has type 0)
        // then we deduct that the format should be word
        if (firstStimExtension === '.' && columnForTrial('type', trialIndex) !== 'instructions') {
            firstStimExtension = 'word';
        }

        // if the extension is unknown and we are not dealing with an instructions trial, then we consider the stim to be a word
        if (!window.imageAudioVideoFormats.includes(firstStimExtension) && columnForTrial('type', trialIndex) !== 'instructions') {
            firstStimExtension = 'word';
        }

        return getTrialTypeForExtension(firstStimExtension);
    }

    function computeTrialTypeFromStimFormat(trialIndex) {
        const stimFormat = columnForTrial('stimFormat', trialIndex)

        return getTrialTypeForExtension(stimFormat);
    }

    function getTrialTypeForExtension(extension) {
        let trialType = 0;

        switch (extension) {
            case '.bmp':
            case '.gif':
            case '.jpeg':
            case '.jpg':
            case '.pdf':
            case '.png':
            case '.webp':
            //SHOULD REMOVE/DEPRECATE IF EXISTS ON LIVE
            case '.tiff':
                trialType = 1;/*images*/
                break;
            case 'word':
                trialType = 2;/*words*/
                break;
            case '.aac':
            case '.flac':
            case '.m4a':
            case '.mp3':
            case '.ogg':
            case '.opus':
            case '.wav':
            //SHOULD REMOVE/DEPRECATE IF EXISTS ON LIVE
            case '.aiff':
            case '.wma':
                trialType = 3;/*sounds*/
                break;
            case '.mp4':
            case '.webm':
            //SHOULD REMOVE/DEPRECATE IF EXISTS ON LIVE
            case '.ogv':
            case '.wmv':
            case '.avi':
            case '.flv':
            case '.mkv':
            case '.mov':
                trialType = 4;/*movies*/
                break;
            case 'survey':
                trialType = 5;/*survey*/
                break;
            case 'html':
                trialType = 7;/*app*/
                break;
            default:
                trialType = 0;/*instructions*/
                break;
        }

        return trialType;
    }
}
